// Injected by vite.config.ts, which derives it from the branch being built.
declare const __PULSATE_API_URL__: string

/**
 * The Web SDK API base URL, fixed at build time.
 *
 * Production builds (branch `main`) get web.pulsatehq.com; every other build,
 * including previews and local development, gets staging. See vite.config.ts
 * for why this is not a plain build variable.
 */
export default function getApiUrl(): string {
  return __PULSATE_API_URL__
}
